import { gql } from 'graphql-request';

import AudioFragment from 'models/Audio/AudioFragment';
import ContributorsFragment from 'models/Contributors/ContributorFragment';
import PrimaryCollectionFragment from 'models/PrimaryCollection/PrimaryCollectionFragment';
import PrimaryVisualsFragment from 'models/PrimaryVisuals/PrimaryVisualsFragment';

const QUERY = gql`
  query Story(
    $contentAreaSlug: String!
    $slug: String!
    $previewToken: String
  ) {
    story(
      contentAreaSlug: $contentAreaSlug
      slug: $slug
      previewToken: $previewToken
    ) {
      id
      title
      originalSourceUrl
      seoHeadline
      shortTitle
      subtitle
      templateName
      summary
      canonicalSlug
      publishDate
      publishedTags
      updatedAt
      updatedPublishDate
      body
      allowComments
      doNotCrawl
      slugs
      dateline
      primaryCollection {
        ${PrimaryCollectionFragment}
      }

      collections {
        rssUrl
        title
        canonicalSlug
      }
      contributors {
        ${ContributorsFragment}
      }
      description
      descriptionText
      resourceType
      primaryAudio {
        ${AudioFragment}
        transcriptText
      }
      embeddedAssets {
        audio
        attachments
        images
        oembeds
      }
      primaryVisuals {
        ${PrimaryVisualsFragment}
      }
    }
  }
`;

export default QUERY;
